<template>
  <div>
    <div class="form_container">
      <div>
        <img
          v-if="!imageSrc"
          src="@/assets/images/icons/upload-icon.svg"
          id="file"
        />
        <img v-else :src="imageSrc" class="h-10 w-auto" id="file" />
      </div>
      <div
        class="remove-icon"
        v-show="bulkUploads.file"
        @click.stop="clearFile"
      >
        <feather-icon
          icon="XIcon"
          title="remove"
          svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
        />
      </div>
      <input type="file" class="form__file" @change="changeDocument" />
      <div class="status">
        <div class="status-row">
          <span class="file-name">{{ fileStatus }}</span>
          <feather-icon
            v-if="(existingFile && existingFile.type && existingFile.type.startsWith('image/'))"
            title="Preview Image"
            icon="EyeIcon"
            @click.stop="showPreview = true"
            class="eye-icon ml-2 text-success"
            svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
          />
          <feather-icon
            v-show="existingFile"
            title="Download Uploaded File"
            icon="DownloadIcon"
            @click.stop="downloadFile()"
            class="download-icon icon_row ml-3 text-warning"
            svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
          />
        </div>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('View Image')"
        :active.sync="showPreview"
        class="popup-close"
      >
        <div>
          <img v-if="existingFile && existingFile.location" :src="existingFile.location" alt="Image Preview" class="w-full h-auto object-contain"/>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
export default {
  name: "pick-file",
  props: {
    existingFile: {
    type: Object,
    default: null,
  },
  },
  data() {
    return {
      bulkUploads: {
        file: null,
      },
      fileStatus: "",
      showPreview: false,
      imageSrc: "",
    };
  },
  computed: {},
  methods: {
    changeDocument(event) {
      const file = event.target.files ? event.target.files[0] : null;
      this.bulkUploads.file = file;
      this.fileStatus = file ? file.name : "No File Selected";

      if (!file) return;

      const fileType = file.type;

      if (fileType.startsWith("image/")) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imageSrc = reader.result;
        };
      } else {
        if (fileType === "application/pdf") {
          this.imageSrc = require("@/assets/images/icons/pdf.png");
        } else if (
          fileType === "application/msword" ||
          fileType ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          this.imageSrc = require("@/assets/images/icons/docx.png");
        } else if (
          fileType === "application/vnd.ms-excel" ||
          fileType ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.imageSrc = require("@/assets/images/icons/excel.png");
        } else {
          this.imageSrc = "";
        }
      }
      this.$emit("fileUpdate", file);
    },
    downloadFile() {
      const url = this.existingFile.location;
      const filename = this.existingFile.fileName;
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getPreviewFromFile(file) {
      const mimeType = file.type || "";
      const fileUrl = file.location || "";

      if (!fileUrl) {
        this.imageSrc = "";
        this.fileStatus = "No File Found";
        return;
      }

      if (mimeType.startsWith("image/")) {
        this.imageSrc = fileUrl;
        this.fileStatus = file.fileName || "Image File";
      } else if (mimeType === "application/pdf") {
        this.imageSrc = require("@/assets/images/icons/pdf.png");
        this.fileStatus = file.fileName || "PDF Document";
      } else if (
        mimeType === "application/msword" ||
        mimeType ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        this.imageSrc = require("@/assets/images/icons/docx.png");
        this.fileStatus = file.fileName || "Word Document";
      } else if (
        mimeType === "application/vnd.ms-excel" ||
        mimeType ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.imageSrc = require("@/assets/images/icons/excel.png");
        this.fileStatus = file.fileName || "Excel Document";
      } else {
        this.imageSrc = "";
        this.fileStatus = file.fileName || "Unsupported File Type";
      }

      this.bulkUploads.file = file;
    },
    clearFile() {
      this.bulkUploads.file = null;
      this.imageSrc = "";
      this.fileStatus = "No File Selected";
      this.$emit("fileUpdate", this.bulkUploads.file);
    },
    closedpopup() {
      this.$emit("closeWarning");
    },
  },
  components: {},
  watch: {
    existingFile(newVal) {
    if (newVal) {
      this.getPreviewFromFile(newVal);
    }
  },
  },
};
</script>

<style lang="scss" scoped>
.form_container {
  position: relative;
  width: 100%;
  height: 5.5rem;
  border: 2px dashed #bbb5ff;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  color: silver;
  background: #e9e7ff;
  border-radius: 12px;
  border-color: #bbb5ff;

  .status {
    position: absolute;
    bottom: 4px;
    font-size: 0.8rem;
    text-align: center;
    display: block;
    width: 100%;
  }
  .remove-icon {
    position: absolute;
    top: 0.3rem;
    right: 0.3rem;
    color: red;
    display: block;
    background: #f7f7f7;
    width: 25px;
    height: 25px;
    box-shadow: 2px 1px 1px #bebebe;
    text-align: center;
    vertical-align: middle;
    border-radius: 50%;
    z-index: 10;
    .feather-icon {
      display: inline;
      vertical-align: middle;
    }
  }
}
.form__file {
  position: absolute;
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
  cursor: pointer;
  opacity: 0;
}
.form_container img {
  margin: 0 auto;
  width: 50px;
  margin-top: 5px;
  display: block;
}
.status-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .file-name {
    font-size: 0.8rem;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }

  .download-icon {
    display: flex;
    align-items: center;
    text-decoration: none;
  }
}
</style>
